import "./Style.scss";
import React, { useState } from "react";
import IwdErrorScreen from "../../mini-components/IwdErrorScreen";
import IwdScreenLoader from "../../mini-components/IwdScreenLoader";
import Api from "../../../utils/api";
import isEmpty from "lodash/isEmpty";
import { PrimaryButton } from "../../common/Button";
const GENERIC_ERR_MSG = "Something went wrong. Please try again";

export default function OtherStatements() {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const retry = () => {
    setHasError(false);
    onClickHandler();
  };
  const getServiceRedirectionUrl = async (payload = {}) => {
    try {
      const res = await Api.post(
        `/api/iam/redirect_url/tp/authenticated/users/aegis`,
        payload
      );
      if (
        res.pfwstatus_code !== 200 ||
        !res.pfwresponse ||
        isEmpty(res.pfwresponse)
      ) {
        throw GENERIC_ERR_MSG;
      }

      const { result, status_code: status } = res.pfwresponse;

      if (status === 200) {
        return result;
      } else {
        throw result.message || result.error || GENERIC_ERR_MSG;
      }
    } catch (e) {
      throw e;
    }
  };

  const onClickHandler = async () => {
    setIsLoading(true);
    const payload = {
      platform: "fisdom",
      action: "iwd_statements",
      theme: "light",
      app: "web",
    };
    try {
      const res = await getServiceRedirectionUrl(payload);
      window.open(res.redirect_url, "_blank");
    } catch (e) {
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  };

  if (hasError) {
    return (
      <div className="iwd-statement-trans-error">
        <IwdErrorScreen
          hasError={true}
          templateErrTitle="Oops!"
          templateErrText="Something went wrong! Please retry after some time or contact your wealth manager"
          templateBtnText="Retry"
          clickHandler={retry}
        />
      </div>
    );
  }
  if (isLoading) {
    return (
      <div className="iwd-statement-trans-loader">
        <IwdScreenLoader loadingText="Redirecting to statements..." />
      </div>
    );
  }

  return (
    <div className="os-button-container">
      <PrimaryButton onClick={onClickHandler}>
        Click here to View Other Statements
      </PrimaryButton>
    </div>
  );
}
